import { c as _c } from "react/compiler-runtime";
import React from "react";
import { IconProps } from "types/icon";
const PlaceholderImage: React.FC<IconProps> = t0 => {
  const $ = _c(14);
  let attributes;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      size: t1,
      color: t2,
      ...attributes
    } = t0);
    $[0] = t0;
    $[1] = attributes;
    $[2] = t1;
    $[3] = t2;
  } else {
    attributes = $[1];
    t1 = $[2];
    t2 = $[3];
  }
  const size = t1 === undefined ? "20" : t1;
  const color = t2 === undefined ? "currentColor" : t2;
  let t3;
  let t4;
  let t5;
  if ($[4] !== color) {
    t3 = <path d="M15.3141 3.16699H4.68453C3.84588 3.16699 3.16602 3.84685 3.16602 4.6855V15.3151C3.16602 16.1537 3.84588 16.8336 4.68453 16.8336H15.3141C16.1527 16.8336 16.8326 16.1537 16.8326 15.3151V4.6855C16.8326 3.84685 16.1527 3.16699 15.3141 3.16699Z" stroke={color} strokeWidth="1.53749" strokeLinecap="round" strokeLinejoin="round" />;
    t4 = <path d="M7.91699 9.16699C8.60735 9.16699 9.16699 8.60735 9.16699 7.91699C9.16699 7.22664 8.60735 6.66699 7.91699 6.66699C7.22664 6.66699 6.66699 7.22664 6.66699 7.91699C6.66699 8.60735 7.22664 9.16699 7.91699 9.16699Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    t5 = <path d="M16.6667 12.5756L13.0208 9.1665L5 16.6665" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    $[4] = color;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
  }
  let t6;
  if ($[8] !== attributes || $[9] !== size || $[10] !== t3 || $[11] !== t4 || $[12] !== t5) {
    t6 = <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>{t3}{t4}{t5}</svg>;
    $[8] = attributes;
    $[9] = size;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};
export default PlaceholderImage;